import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../utils/context/AuthContext';

const PublicRoute = ({ children }) => {
  const { isLoggedIn, ready } = useAuth();

  if (!ready) return null;

  return !isLoggedIn ? children : <Navigate to="/" />;
};

export default PublicRoute;
